import React from "react";

const TopRated = () => {
  return (
    <div>
      <h1>hello top rated</h1>
    </div>
  );
};

export default TopRated;
